import React, { PropsWithChildren } from 'react';
import ReactModal from 'react-modal';

import { css } from '@emotion/react';
import { Box, Button } from '@opendoor/bricks/core';
import { novo } from '@opendoor/bricks/theme';

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect
      width="17.0837"
      height="2.08338"
      rx="1.04169"
      transform="matrix(0.70709 -0.707124 0.70709 0.707124 3.21875 15.3047)"
      fill="#3D3C3B"
    />
    <rect
      width="17.0837"
      height="2.08338"
      rx="1.04169"
      transform="matrix(0.70709 0.707124 -0.70709 0.707124 4.69531 3.22266)"
      fill="#3D3C3B"
    />
  </svg>
);

const CONTENT_STYLES: React.CSSProperties = {
  borderRadius: '30px',
  WebkitOverflowScrolling: 'touch',
  outline: 'none',
  border: 'none',
  position: 'absolute',
  inset: 'auto',
  padding: 0,

  display: 'flex',
  width: 'calc(100vw - 40px)',
  maxWidth: '640px',
  flexDirection: 'column',
};

const OVERLAY_STYLES: React.CSSProperties = {
  backgroundColor: 'rgba(0, 0, 0, 0.72)',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
};

type NovoModalCardProps = {
  isOpen: boolean;
  onModalClose: () => void;
  children: React.ReactNode;
};

const NovoModalCard: React.FC<PropsWithChildren<NovoModalCardProps>> = ({
  isOpen = false,
  onModalClose,
  children,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      /*
        Accessibility note: Aria-model indicates the presence of a modal element
        https://www.w3.org/TR/wai-aria-1.2/#aria-modal
      */
      aria-modal={isOpen}
      onRequestClose={onModalClose}
      shouldFocusAfterRender
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      shouldReturnFocusAfterClose
      style={{
        content: CONTENT_STYLES,
        overlay: OVERLAY_STYLES,
      }}
    >
      <Button
        width="32px"
        height="32px"
        minHeight="32px"
        padding="6px"
        // @ts-expect-error borderRadius isn't a prop on buttons
        borderRadius={novo.radii.full}
        // backgroundColor="#F2F1F0"
        backgroundColor="warmgrey200"
        _hover={{ backgroundColor: novo.colors.warmgrey300 }}
        onClick={onModalClose}
        mt={['14px', null, '16px']}
        mr={['14px', null, '16px']}
        alignSelf="flex-end"
      >
        <CloseIcon />
      </Button>
      <Box
        margin={[6, null, 11]}
        mt={[0, 0, 0]}
        css={css`
          @media (min-width: 425px) and (max-width: 767px) {
            margin: ${novo.space[9]};
            margin-top: 0px;
          }
        `}
      >
        {children}
      </Box>
    </ReactModal>
  );
};

export default NovoModalCard;
